<!-- 验证码 -->

<template>
    <div class="verify">
        <div class="verify-header">
            <span class="verify-title">领取码：</span>
            <span class="verify-box" v-for="n in verify" :key="n.value">{{n.value}}</span>
        </div>
        <div class="error-tips" v-if="error">
            <p>输入错误！请重新输入（剩余{{chance}}次机会）</p>
        </div>
        <div class="keyboard">
            <span class="key" v-for="n in 9" :key="n" @click="press(n)">{{n}}</span>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                error: false,
                chance: 3,
                verify: [{
                    value: '',
                },{
                    value: '',
                },{
                    value: '',
                },{
                    value: '',
                }],
            }
        },
        methods: {
            press (v) {
                for (let i in this.verify) {
                    if (this.verify[i].value == '') {
                        this.verify[i].value = v
                        if (i  == 3) {
                            this.verifySubmit()
                        }else {
                            return false;
                        }
                    }
                    
                }
            },
            verifySubmit () {
                alert('提交')
            }
        }
    }
</script>
<style lang="less" scoped>
    p {
        margin: 0;
    }
    .verify-header, .error-tips {
        padding: 0 5.5vw;
    }
    .verify-header {
        margin-bottom: 2.666vw;
        display: flex;
        align-items: center;
    }
    .verify-title {
        color: #9a9a9a;
        font-size: 3.733333vw;
    }
    .verify-box {
        display: inline-block;
        width: 10.1333vw;
        height: 10.4vw;
        text-align: center;
        border: 1px solid #d1d1d1;
        border-radius: 5px;
        line-height: 10.4vw;
        margin-right: 2.2666vw;
        font-weight: bold;
    }
    .verify-box:last-child {
        margin: 0
    }
    .error-tips {
        font-size: 3.0666vw;
        color: #fc0228;
    }
    .keyboard {
        margin-top: 5.3333vw;
        background: #f3f2f1;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 5.8666vw 8.33333vw;
        .key {
            display: inline-block;
            width: 16.4vw;
            height: 8vw;
            background: #ffa044;
            color: #fff;
            font-size: 3.7333vw;
            font-weight: bold;
            text-align: center;
            line-height: 8vw;
            border-radius: 15px;
            // margin-right: 4vw;
            margin-bottom: 2.5333vw;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/orders/verify.vue